import { render, staticRenderFns } from "./AddressNew.vue?vue&type=template&id=06597447&scoped=true&"
import script from "./AddressNew.vue?vue&type=script&lang=js&"
export * from "./AddressNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06597447",
  null
  
)

export default component.exports